export const toggleSound = () => {
  if (document.querySelectorAll('.toggle-sound').length > 0) {
    document.querySelectorAll('.toggle-sound').forEach((toggle) => {
      const videoElement = toggle.closest('.wideo__wrapper').querySelector('video');
      toggle.addEventListener('click', () => {
        if (videoElement.muted) {
          videoElement.muted = false;
          toggle.classList.add('sound--on');
        } else {
          videoElement.muted = true;
          toggle.classList.remove('sound--on');
        }
      });
    });
  }
};
